import API from "../api/apiUser";

/**
 * Service for fetching public Press data (Coverage & Featured Quotes).
 */
export const UserPressService = {
    /**
     * Fetches all active press coverage items.
     * @returns {Promise<Array>} List of press coverage objects.
     */
    getPressCoverage: async () => {
        try {
            const response = await API.get("/user/press/coverage");
            return response.data;
        } catch (error) {
            console.error("Error fetching press coverage:", error);
            throw error;
        }
    },

    /**
     * Fetches all active featured quotes.
     * @returns {Promise<Array>} List of quote objects.
     */
    getPressQuotes: async () => {
        try {
            const response = await API.get("/user/press/quotes");
            return response.data;
        } catch (error) {
            console.error("Error fetching press quotes:", error);
            throw error;
        }
    },

    /**
     * Fetches the current EPK info.
     * @returns {Promise<Object>} EPK object.
     */
    getEPK: async () => {
        try {
            const response = await API.get("/user/press/epk");
            return response.data;
        } catch (error) {
            console.error("Error fetching EPK:", error);
            throw error;
        }
    }
};
